module.exports = __webpack_public_path__ + "img/alert-unread.1749152d.svg";